module.exports = __webpack_public_path__ + "static/2016-layer-3-9d274889e25e7168e375b89ae757281b.png";